export default "__VITE_ASSET__D8FL7wGR__"